import {RouteView, PageView} from '../layouts'

export const active = {
    path: '/active',
    name: 'BaseForm',
    component: PageView,
    meta: {title: '活动统计', icon: 'stock', isMenuShow: true, permission: 'oddactv'},
    children: [
        {
            path: '/active/secretCode',
            redirect: '/active/secretCode/code',
            name: 'secretCode',
            component: () => import('../views/activity/secretCode/tabs.vue'),
            meta: {title: '密令活动', keepAlive: false, isMenuShow: true, permission: 'oddactv'},
            children: [
                // {
                //     path: '/active/secretCode/tabs',
                //     components:{
                //         code: () => import('../views/activity/secretCode/code.vue'),
                //         ball: () => import('../views/activity/secretCode/ball.vue'),
                //     }
                // },
                {
                    path: '/active/secretCode/code',
                    name: 'secretCode',
                    component: () => import('../views/activity/secretCode/code.vue'),
                    meta: {title: '密令', keepAlive: false, isMenuShow: true, permission: 'oddactv:so'},
                },
                {
                    path: '/active/secretCode/ball',
                    name: 'secretCode',
                    component: () => import('../views/activity/secretCode/ball.vue'),
                    meta: {title: '红篮球', keepAlive: false, isMenuShow: true, permission: 'oddactv:3b'},
                },
            ]
        },
        {
            path: '/active/orangeOrder',
            name: 'secretCode',
            component: () => import('../views/activity/orange.vue'),
            meta: {title: '订单查询', keepAlive: false, isMenuShow: true,permission: 'oddactv'},
        },
        {
            path: '/active/fightNcov',
            redirect: '/active/fightNcov/publish',
            name: 'secretCode',
            component: () => import('../views/activity/fightNcov/tabs.vue'),
            meta: {title: '共抗疫情活动', keepAlive: false, isMenuShow: true, permission: 'oddactv'},
            children: [
                {
                    path: '/active/fightNcov/publish',
                    name: 'secretCode',
                    component: () => import('../views/activity/fightNcov/publish.vue'),
                    meta: {title: '疫情数据发布', keepAlive: false, isMenuShow: true, permission: 'oddactv:so'},
                },
                {
                    path: '/active/fightNcov/donation',
                    name: 'secretCode',
                    component: () => import('../views/activity/fightNcov/donation.vue'),
                    meta: {title: '捐赠池', keepAlive: false, isMenuShow: true, permission: 'oddactv:3b'},
                },
            ]
        },
    ]
}

